"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _server = require("react-dom/server");
var _constants = require("../constants");
var _utils = require("../utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var convertProps = function convertProps(propsParam) {
  var newProps = _objectSpread({}, propsParam);
  try {
    var _propsParam$options, _propsParam$options2;
    // in order to avoid React version mismatch issues that appear if we are passed a React Component originally created with React 16
    // as a contentBefore or contentAfter ingressOption, we convert the component into a string here and then parse it in HMHAPI
    if (propsParam !== null && propsParam !== void 0 && (_propsParam$options = propsParam.options) !== null && _propsParam$options !== void 0 && (_propsParam$options = _propsParam$options.ingressOptions) !== null && _propsParam$options !== void 0 && _propsParam$options.contentBefore && typeof propsParam.options.ingressOptions.contentBefore !== 'string') {
      newProps.options.ingressOptions.contentBefore = (0, _server.renderToStaticMarkup)(propsParam.options.ingressOptions.contentBefore);
    }
    if (propsParam !== null && propsParam !== void 0 && (_propsParam$options2 = propsParam.options) !== null && _propsParam$options2 !== void 0 && (_propsParam$options2 = _propsParam$options2.ingressOptions) !== null && _propsParam$options2 !== void 0 && _propsParam$options2.contentAfter && typeof propsParam.options.ingressOptions.contentAfter !== 'string') {
      newProps.options.ingressOptions.contentAfter = (0, _server.renderToStaticMarkup)(propsParam.options.ingressOptions.contentAfter);
    }
  } catch (ex) {
    console.log('error in convert props', ex);
  }
  return newProps;
};
var HMHAnchor = function HMHAnchor(props) {
  var _props$options4;
  var newProps = convertProps(props);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isIntersecting = _useState2[0],
    setIsIntersecting = _useState2[1];
  var _useState3 = (0, _react.useState)((0, _utils.generateUuid)()),
    _useState4 = _slicedToArray(_useState3, 1),
    uuid = _useState4[0];
  function useIsInViewport(ref) {
    if (window.IntersectionObserver) {
      var observer = new window.IntersectionObserver(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 1),
          entry = _ref2[0];
        setIsIntersecting(entry.isIntersecting);
      });
      observer.observe(ref.current);
    }
  }
  var ref = (0, _react.useRef)(null);
  var isInitialMount = (0, _react.useRef)(true);
  (0, _react.useEffect)(function () {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      if (ref && ref.current) {
        useIsInViewport(ref);
      }
    }
  });
  (0, _react.useEffect)(function () {
    if (isIntersecting) {
      document.dispatchEvent(new CustomEvent(_constants.EMIT_MESSAGES.HMH_SHOW_TOOLTIPS, {
        detail: _objectSpread(_objectSpread({}, newProps), {}, {
          anchor: ref.current,
          uuid: uuid
        })
      }));
    } else {
      document.dispatchEvent(new CustomEvent(_constants.EMIT_MESSAGES.HMH_HIDE_TOOLTIPS, {
        detail: _objectSpread(_objectSpread({}, newProps), {}, {
          anchor: ref.current,
          uuid: uuid
        })
      }));
    }
  }, [isIntersecting]);
  (0, _react.useEffect)(function () {
    var interval = setInterval(function () {
      var _props$options, _window, _props$options2;
      if (!window[_constants.HMH_LOADED] && !(props !== null && props !== void 0 && (_props$options = props.options) !== null && _props$options !== void 0 && _props$options.isFromiFrame && (_window = window) !== null && _window !== void 0 && (_window = _window.parent) !== null && _window !== void 0 && _window[_constants.HMH_LOADED])) {
        return;
      }
      if (props !== null && props !== void 0 && (_props$options2 = props.options) !== null && _props$options2 !== void 0 && _props$options2.isFromiFrame) {
        var _window2;
        (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.parent) === null || _window2 === void 0 || (_window2 = _window2.document) === null || _window2 === void 0 || _window2.dispatchEvent(new CustomEvent(_constants.EMIT_MESSAGES.HMH_RENDER_INGRESS, {
          detail: _objectSpread(_objectSpread({}, newProps), {}, {
            anchor: ref.current,
            uuid: uuid
          })
        }));
      } else {
        document.dispatchEvent(new CustomEvent(_constants.EMIT_MESSAGES.HMH_RENDER_INGRESS, {
          detail: _objectSpread(_objectSpread({}, newProps), {}, {
            anchor: ref.current,
            uuid: uuid
          })
        }));
      }
      clearInterval(interval);
    }, 25);
    return function () {
      var _props$options3;
      // RUNS WHEN HMH INGRESS IS UNMOUNTED
      if (props !== null && props !== void 0 && (_props$options3 = props.options) !== null && _props$options3 !== void 0 && _props$options3.isFromiFrame) {
        var _window3;
        (_window3 = window) === null || _window3 === void 0 || (_window3 = _window3.parent) === null || _window3 === void 0 || (_window3 = _window3.document) === null || _window3 === void 0 || _window3.dispatchEvent(new CustomEvent(_constants.EMIT_MESSAGES.HMH_CLOSE_EVENT, {
          detail: _objectSpread(_objectSpread({}, newProps), {}, {
            uuid: uuid
          })
        }));
      } else {
        document.dispatchEvent(new CustomEvent(_constants.EMIT_MESSAGES.HMH_CLOSE_EVENT, {
          detail: _objectSpread(_objectSpread({}, newProps), {}, {
            uuid: uuid
          })
        }));
      }
    };
  }, [props === null || props === void 0 || (_props$options4 = props.options) === null || _props$options4 === void 0 ? void 0 : _props$options4.isFromiFrame]);

  // eslint-disable-next-line react/no-unknown-property
  return /*#__PURE__*/_react["default"].createElement("span", {
    ref: ref,
    content_id: props.contentId,
    page_id: props.pageId
  });
};
var _default = exports["default"] = HMHAnchor;
//# sourceMappingURL=HMHAnchor.js.map